export default __webpack_public_path__ + "static/media/icons-enroll.d633148d.svg";